import React from 'react';
import { useAppointmentModal } from '../context/AppointmentModalContext';
import Header from './Header';
import Footer from './Footer';
import Seo from './Seo';
import { breadcrumbJsonLd } from '../seo/structuredData';
import { useI18n } from '../i18n/I18nContext';
import './Contact.css';

function Contact() {
  const { openModal } = useAppointmentModal();
  const { lang, copy } = useI18n();

  return (
    <div className="michaela-contact-page">
      <Seo
        page="kontakt"
        jsonLd={breadcrumbJsonLd([
          { name: 'Home', path: lang === 'en' ? '/en' : '/' },
          { name: copy.contact.crumb, path: lang === 'en' ? '/en/contact' : '/kontakt' },
        ])}
      />
      <Header />
      
      <section className="michaela-contact-main">
        <div className="michaela-contact-container">
          <div className="michaela-contact-header">
            <p className="michaela-contact-label">{copy.contact.label}</p>
            <h1 className="michaela-contact-title">{copy.contact.title}</h1>
            <p className="michaela-contact-subtitle">
              {copy.contact.intro}
            </p>
          </div>

          <div className="michaela-contact-cards">
            <a href="mailto:mb@michaelabraun.de" className="michaela-contact-card">
              <div className="michaela-contact-card-content">
                <h3 className="michaela-contact-card-title">{copy.contact.email}</h3>
                <p className="michaela-contact-card-value">mb@michaelabraun.de</p>
              </div>
            </a>

            <a href="tel:+498988909372" className="michaela-contact-card">
              <div className="michaela-contact-card-content">
                <h3 className="michaela-contact-card-title">{copy.contact.office}</h3>
                <p className="michaela-contact-card-value">+49 89 88909 372</p>
              </div>
            </a>

            <a href="tel:+491718208818" className="michaela-contact-card">
              <div className="michaela-contact-card-content">
                <h3 className="michaela-contact-card-title">{copy.contact.mobile}</h3>
                <p className="michaela-contact-card-value">+49 171 8208818</p>
              </div>
            </a>
          </div>

          <div className="michaela-contact-cta">
            <p className="michaela-contact-cta-text">
              {copy.contact.ask}
            </p>
            <button 
              onClick={openModal}
              className="michaela-contact-button"
            >
              {copy.contact.cta}
            </button>
          </div>
        </div>
      </section>

      <Footer showContactForm={false} />
    </div>
  );
}

export default Contact;
